module.exports = {"classes":["editable-subscriptions-page","header-dark"],"title":"Editable Subscriptions","metas":{"description":"This page provides customers and prospects with editable versions of the Auth0 Subscription Agreement and Professional Services Terms."},"opengraph":{"og:title":"Editable Subscriptions","og:description":"This page provides customers and prospects with editable versions of the Auth0 Subscription Agreement and Professional Services Terms.","og:url":"https://auth0.com/legal/baseline/edit"}}


//////////////////
// WEBPACK FOOTER
// ./src/pages/legals/editable-subscriptions/metadata.json
// module id = 1637
// module chunks = 0